import { Children, ReactNode } from 'react'

const hasVisibleChildren = (
  children: ReactNode,
  isLoading?: boolean,
): boolean => {
  if (isLoading) return true
  return Children.toArray(children).length > 0
}

export const PageHeaderTagsRowParts = {
  hasVisibleChildren,
}
